'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

CommandButtonDirective=function(_BaseControllerBacked){_inherits(CommandButtonDirective,_BaseControllerBacked);function CommandButtonDirective(){_classCallCheck(this,CommandButtonDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(CommandButtonDirective,[{key:'objectBindings',get:function()
{
return['command'];
}},{key:'textBindings',get:function()

{
return['text','inProgressText','completionText'];
}},{key:'templateUrl',get:function()

{
return'/templates/directives/commandButtonDirective/commandButtonTemplate';
}},{key:'controller',get:function()

{
return CommandButtonDirectiveController;
}}]);return CommandButtonDirective}(BaseControllerBackedDirective);let


CommandButtonDirectiveController=function(){_createClass(CommandButtonDirectiveController,null,[{key:'$inject',get:function()
{
return[];
}}]);

function CommandButtonDirectiveController(){_classCallCheck(this,CommandButtonDirectiveController);
this.completionText=this.completionText||'';
}_createClass(CommandButtonDirectiveController,[{key:'showDefaultText',get:function()

{
return!this.command.inProgress&&!this.command.completed;
}},{key:'showInProgressText',get:function()

{
return this.command.inProgress||this.command.completed&&this.completionText.length===0;
}},{key:'showCompletionText',get:function()

{
return this.command.completed&&this.completionText.length>0;
}}]);return CommandButtonDirectiveController}();



module.exports=CommandButtonDirective;
module.exports.controller=CommandButtonDirectiveController;
//# sourceMappingURL=commandButtonDirective.js.map
